import { render, staticRenderFns } from "./OInput.vue?vue&type=template&id=6cb5ebbb&scoped=true&"
import script from "./OInput.vue?vue&type=script&lang=js&"
export * from "./OInput.vue?vue&type=script&lang=js&"
import style0 from "./OInput.vue?vue&type=style&index=0&id=6cb5ebbb&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5ebbb",
  null
  
)

export default component.exports